
import { Base } from '../base-component';

import { TooltipsService } from '../../services/tooltips.service';

import './product-offering.component.scss';

import * as $ from 'jquery';
import * as _ from 'lodash';

import { AnalyticsService } from 'services/analytics.service';

declare var jsonData;

export class ProductOffering extends Base {

	endpoint: string;
	productKey: string;
	filterJson: any;
	productJson: any;
	comparison: any;
	comparable: boolean;
	productContainer: JQuery<HTMLElement>;
	compareCard: JQuery<HTMLElement>;
	removeAll: JQuery<HTMLElement>;
	filterItem: JQuery<HTMLElement>;
	producttype: string;

	constructor(element: Element, analyticsService: AnalyticsService) {
		super(element);
	}

	init() {

		let storage: any = localStorage.getItem('comparison');
		this.endpoint = this.element.getAttribute('data-endpoint');
		this.productKey = this.element.getAttribute('data-productkey');
		this.productContainer = $('.product-card-wrapper');
		this.removeAll = $('.js-remove-all');

		this.producttype = $("div.component.product-offering").attr('data-producttype');
		if (this.producttype) {
			this.producttype = this.producttype.toLowerCase();
		}

		if (!storage) {
			storage = {};
			storage[this.productKey] = [];
			localStorage.setItem('comparison', JSON.stringify(storage));
		} else {
			storage = JSON.parse(storage);
			if (!storage[this.productKey]) {
				storage[this.productKey] = [];
				localStorage.setItem('comparison', JSON.stringify(storage));
			}
		}

		this.comparison = storage;
		this.getProducts();
		TooltipsService.initTooltips();
	}

	bindEvents() {
		$(document).on('click', '.js-remove-compare', (e) => {
			let productId = $(e.currentTarget).data('id');
			if (this.comparison[this.productKey].find((item) => { return item == productId })) {
				let index = this.comparison[this.productKey].indexOf(productId);
				if (index >= 0) {
					this.comparison[this.productKey].splice(index, 1);
					localStorage.setItem('comparison', JSON.stringify(this.comparison));
					if (this.comparison[this.productKey].length >= 2) {
						$('.js-compare-button').removeClass('button--disabled');
					} else {
						$('.js-compare-button').addClass('button--disabled');
					}

					$(`.form__control--checkbox input`).removeAttr('disabled');
					$(`.product-card[data-id='${productId}'] .product-card__outer`).removeClass("gradient-border");
					$(`.form__control--checkbox[data-id='${productId}'] input`).prop('checked', false);
					$(`.product-offering__compare-chip[data-id='${productId}']`).addClass('product-offering__compare-chip--hide');

					setTimeout(() => {
						$(`.product-offering__compare-chip[data-id='${productId}']`).remove();
						if (!this.productComparisonCheck()) {
							$('.product-offering__compare').removeClass('product-offering__compare--active');
						}
					}, 300);
				}
			}
		});

		this.removeAll.click((e) => {
			e.preventDefault();

			$(`.product-card .product-card__outer`).removeClass("gradient-border");
			$(`.form__control--checkbox input`).removeAttr('disabled');
			$(`.form__control--checkbox input`).prop('checked', false);
			$(`.product-offering__compare-chip`).addClass('product-offering__compare-chip--hide');

			setTimeout(() => {
				$(`.product-offering__compare-chip`).remove();
				this.comparison[this.productKey] = [];
				localStorage.setItem('comparison', JSON.stringify(this.comparison));
				$('.product-offering__compare').removeClass('product-offering__compare--active');
				$('.js-compare-button').removeClass('button--disabled');
			}, 300);
		});

		window.addEventListener('resize', this.debounce(() => {
			this.normalizeCardHeight();
		}, 50, false));
	}

	getProducts() {
		let parseData = jsonData;
		this.filterJson = parseData.filters;
		this.productJson = parseData.products;

		this.comparable = _.some(this.productJson, (product) => {
			return product.comparable;
		});

		if (document.querySelector('.product-filter')) {
			this.renderFilters();
		}
		else if (document.querySelector('.product-filter-dropdown')) {
			this.renderDropdownFilters();
		}

		let docfragment = document.createDocumentFragment();

		let iCount = 1;
		this.productJson.forEach(card => {
			docfragment.appendChild(this.renderProduct(card, iCount));
		});

		this.productContainer[0].appendChild(docfragment);
		this.normalizeCardHeight();
		this.compareCard = $('.js-compare');
		this.compareCard.click((e) => this.compareClick(e));

		if (this.comparison) {
			this.comparison[this.productKey].forEach(id => {
				$(`.product-card[data-id='${id}'] .product-card__outer`).addClass("gradient-border");
				$(`.form__control--checkbox[data-id='${id}'] input`).prop('checked', 'checked');
			});

			if (this.comparison[this.productKey].length >= 3) {
				$(`.form__control--checkbox input`).prop('disabled', 'disabled');

				this.comparison[this.productKey].forEach(id => {
					$(`.form__control--checkbox[data-id='${id}'] input`).removeAttr('disabled');
				});
			}

			if (this.comparison[this.productKey].length > 0) {
				let hasComparedProducts = false;

				if (this.productComparisonCheck()) {
					$('.product-offering__compare').addClass('product-offering__compare--active');

					this.comparison[this.productKey].forEach(id => {
						this.renderComparisonChips(id);
					});
				}
			}

			if (this.comparison[this.productKey].length >= 2) {
				$('.js-compare-button').removeClass('button--disabled');
			} else {
				$('.js-compare-button').addClass('button--disabled');
			}
		}
		this.normalizeCardHeight();
	}

	normalizeCardHeight() {

		if ($(window).width() < 951) {
			$('.product-card__content').css('min-height', `initial`);
			$('.product-card__content > p').css('min-height', `initial`);
			$('.product-card__terms').css('min-height', `initial`);
		} else {
			let highestContent = 0;
			$('.product-card__content').each((index, el) => {
				let contentHeight = $(el).outerHeight();
				if (highestContent < contentHeight) {
					highestContent = contentHeight;
				}
			});

			$('.product-card__content').css('min-height', highestContent + 'px');

			let highestParagragh = 0;
			$('.product-card__content > p').each((index, el) => {
				let paragraphHeight = $(el).height();
				if (highestParagragh < paragraphHeight) {
					highestParagragh = paragraphHeight;
				}
			});

			$('.product-card__content > p').css('min-height', highestParagragh + 'px');

			let highestTerms = 0;
			$('.product-card__terms').each((index, el) => {
				let termHeight = $(el).height();
				if (highestTerms < termHeight) {
					highestTerms = termHeight;
				}
			});

			$('.product-card__terms').css('min-height', highestTerms + 'px');
		}
	}

	compareClick(e) {
		let productId = $(e.currentTarget).parent().data('id');

		if (!this.comparison[this.productKey]) {
			this.comparison[this.productKey].push(productId);
			localStorage.setItem('comparison', JSON.stringify(this.comparison));
			this.renderComparisonChips(productId);
			$('.product-offering__compare').addClass('product-offering__compare--active');
			$('.js-compare-button').addClass('button--disabled');
		} else {
			if (this.comparison[this.productKey].find((item) => { return item == productId })) {
				let index = this.comparison[this.productKey].indexOf(productId);
				if (index >= 0) {
					this.comparison[this.productKey].splice(index, 1);
					localStorage.setItem('comparison', JSON.stringify(this.comparison));
					$(".form__control--checkbox input").removeAttr('disabled');
					$(".product-offering__compare-chip[data-id='" + productId + "']").remove();
					$(".product-offering__compare-chip[data-id='" + productId + "']").addClass('product-offering__compare-chip--hide');

					setTimeout(() => {
						$(".product-offering__compare-chip[data-id='" + productId + "']").remove();
						if (!this.productComparisonCheck()) {
							$('.product-offering__compare').removeClass('product-offering__compare--active');
						}
					}, 300);
				}
			} else if (this.comparison[this.productKey].length < 3) {
				this.comparison[this.productKey].push(productId);
				localStorage.setItem('comparison', JSON.stringify(this.comparison));
				this.renderComparisonChips(productId);

				if (this.comparison[this.productKey].length >= 3) {
					$(".form__control--checkbox input").prop('disabled', 'disabled');
					this.comparison[this.productKey].forEach(id => {
						$(".form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
					});
				}
			}

			if (this.productComparisonCheck()) {
				$('.product-offering__compare').addClass('product-offering__compare--active');
			}

			if (this.comparison[this.productKey].length >= 2) {
				$('.js-compare-button').removeClass('button--disabled');
			} else {
				$('.js-compare-button').addClass('button--disabled');
			}
		}

		if ($(".product-card[data-id='" + productId + "'] .product-card__outer").hasClass("gradient-border")) {
			$(".product-card[data-id='" + productId + "'] .product-card__outer").removeClass("gradient-border");
		} else {
			$(".product-card[data-id='" + productId + "'] .product-card__outer").addClass("gradient-border");
		}
	}

	productComparisonCheck() {
		//checks to see if the products from JSON match anything in the local storage
		return _.some(this.comparison[this.productKey], (el) =>
			_.includes(_.map(this.productJson, (prod: any) => { return prod.id }), el)
		);
	}

	renderProduct(input, orderIndex) {
		let productPrices = "";
		let productTags = "";
		let productTerms = "";
		let productButtons = "";

		let termCount = 0;

		input.pricing.forEach(price => {

			if (price.terms) {
				termCount++;
				let asterix = '';
				for (let index = 0; index < termCount; index++) {
					asterix += '*';
				}

				productTerms += '<div><span class="title title--asterisk">' + asterix + '</span><span>' + price.terms + '</span></div>';
			}
			productPrices += this.renderProductPrice(price, termCount);
		});

		let btnCount = 0;

		input.buttons.forEach(btn => {
			productButtons += this.renderButtons(btn, btnCount, input);
			btnCount++;
		});

		productTerms = '<div class="product-card__terms">' + productTerms + '</div>';

		input.tags.forEach(tag => {
			productTags += " " + tag.replace(/ /g, "-");
		});

		let output = "";
		output += '<div class="product-card product-card__image ' + productTags.toLowerCase() + '" data-id="' + input.id + '" style="order: ' + orderIndex + ';">';

		switch(input.title.toLowerCase()) { 
			case "apply for a new student loan": { 
				output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
				if (input.cardImage) {
					output += '<img class="product-card__image--card" src="' + input.cardImage + '">';
				}
			   break; 
			}
			default: { 
				if (input.onPromotion) {
					output += '<div class="product-card__feature-badge feature-badge">' + input.promotionLabel + '</div>';
				}
				if (input.cardImage) {
					output += '<img class="product-card__image--card" src="' + input.cardImage + '">';
				}
			   break; 
			} 
		}

		output += '<div class="product-card__outer"><div class="product-card__inner" data-trackingregion="product offering ' + this.producttype + ' > ' + input.title.toLowerCase() + '"><div class="product-card__content"><h4 class="title title--module-sub-title product-card__title">' + input.title + '</h4><div class="title title-gradient title-gradient--product"></div><p>' + input.subTitle + '</p><div class="row">' + productPrices + '</div></div>';

		//card buttons
		output += '<div class="product-card__buttons"><div class="row"><div class="col-12">' + productTerms + '<div class="float-md-right float-sm-left">';

		if (input.comparable) {
			output += '<label data-id="' + input.id + '" class="form__control form__control--checkbox">Add to compare<input type="checkbox" class="js-compare"><div class="form__control-indicator"></div></label>';
		} else {
			output += '<div class="' + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder -card__compare-placeholder--sml') + '"></div>';
		}

		output += '</div></div>' + productButtons + '</div></div>';

		//end card buttons
		output += '</div>'; //inner close
		output += '</div>'; //outer close
		output += '</div>'; //main close

		return document.createRange().createContextualFragment(output);
	}

	renderButtons(input, index, product) {

		let output = "";
		// Analytics - included the product in the param lis so we can get the prod name
		let productTitle = product.title ? product.title : "<<product name>>";
		if (input.isModal) {
			output += '<div class="' + (index === 0 ? 'product-card__button-wrap' : '') + ' col-xs-6 col-sm-6"><a class="button button--main js-apply-now-modal-open" href="#" target="" data-modal="apply-now-modal-' + input.modalId + '" data-id="link_content_product offering" data-text="' + this.producttype + ' | ' + productTitle + ' | ' + input.title + ' button click">' + input.title + '</a></div>';
		} else {
			output += '<div class="' + (index === 0 ? 'product-card__button-wrap' : '') + ' col-xs-6 col-sm-6"><a class="button button--main ' + (index === 0 ? '' : 'button--white button--border-blue') + '" href="' + input.url + '" target="' + input.target + '" data-id="link_content_product offering" data-text="' + this.producttype + ' | ' + productTitle + ' | ' + input.title + ' button click">' + input.title + '</a></div>';
		}
		return output;
	}

	renderProductPrice(input, termCount?: number) {
		let output = "";

		output += '<div class="product-card__price col-6 col-xs-6 col-sm-6">';

		if (input.symbol && input.symbol.toLowerCase() == 'r') {
			output += '<span class="title title--initial title--currency">' + input.symbol + '</span>';
		}

		if (input.note) {

			output += '<span class="title title--initial product-card__price__note">' + input.title + '</span>';

		} else {

			output += '<span class="title title--initial title--number">' + input.title + '</span>';

		}

		if (input.symbol && input.symbol.toLowerCase() != 'r') {
			output += '<span class="title title--initial title--currency">' + input.symbol + '</span>';
		}

		if (input.tooltip) {
			output += '<span title="' + input.tooltip + ' data-title="' + input.tooltip + '><i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path></svg></i></span>';
		}

		if (input.terms) {
			let asterix = '';
			for (let index = 0; index < termCount; index++) {
				asterix += '*';
			}
			output += '<span class="title title--initial title--asterisk">' + asterix + '</span>';
		}

		if (input.strike) {
			output += '<div class="title title--initial title--number-strike"><span class="title title--number-striker"></span>';
			if (input.symbol) {
				output += '<span class="title title--initial title--currency-sml">' + input.symbol + '</span>';
			}
			output += '<span class="title title--initial title--number-sml">' + input.strike + '</span></div>';
		}

		output += '<div class="title title--notes">' + input.subTitle + '</div>';
		output += '</div>'; //main close
		return output;
	}

	renderComparisonChips(id) {

		let item = this.productJson.find((item) => { return item.id == id });

		let output = "";
		output += '<span class="product-offering__compare-chip" data-id="' + item.id + '"><span class="title title--notes">' + item.title + '</span><i class="icon js-remove-compare" data-id="${item.id}"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd"><circle cx="10" cy="10" r="10" fill="#0089FF"></circle><path fill="#FFF" d="M15 5.604L14.396 5 10 9.396 5.604 5 5 5.604 9.396 10 5 14.396l.604.604L10 10.604 14.396 15l.604-.604L10.604 10 15 5.604"></path></g></svg></i></span>';

		let docfragment = document.createDocumentFragment();
		docfragment.appendChild(document.createRange().createContextualFragment(output));

		$('.product-offering__compare-chip-wrapper')[0].appendChild(docfragment);
		$('.product-offering__compare-chip-wrapper')[0].appendChild(docfragment);
	}

	renderFilters() {

		if (this.filterJson && this.filterJson.length > 0) {
			$('.product-filter').addClass('product-filter--show');
			$('.product-filter').removeClass('product-filter--hide');
			let filterfragment = document.createDocumentFragment();
			this.filterJson.forEach(filter => {
				filterfragment.appendChild(document.createRange().createContextualFragment('<span class="product-filter__item" data-filter="' + filter + '" -id="link_tab_tab" data-text="product offering > ' + filter.toLowerCase() + '">' + filter + '</span>'));
			});
			document.querySelector('.product-filter__wrapper').appendChild(filterfragment);
		} else {
			if (this.filterJson) {
				$('.product-filter').addClass('product-filter--none');
				$('.product-filter').removeClass('product-filter--hide');
				$('.product-filter__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
				$('.product-filter__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));
			}
		}
	}

	renderDropdownFilters() {
		if (this.filterJson && this.filterJson.length > 0) {
			$('.product-filter-dropdown').addClass('product-filter-dropdown--show');
			$('.product-filter-dropdown').removeClass('product-filter-dropdown--hide');
			let filterfragment = document.createDocumentFragment();
			this.filterJson.forEach(filter => {
				filterfragment.appendChild(document.createRange().createContextualFragment('<span class="product-filter-dropdown__item" data-filter="' + filter + '" -id="link_tab_tab" data-text="product offering > ' + filter.toLowerCase() + '">' + filter + '</span>'));
			});
			document.querySelector('.product-filter-dropdown__wrapper').appendChild(filterfragment);
		} else {
			if (this.filterJson) {
				$('.product-filter-dropdown').addClass('product-filter-dropdown--none');
				$('.product-filter-dropdown').removeClass('product-filter-dropdown--hide');
				$('.product-filter-dropdown__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
				$('.product-filter-dropdown__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));
			}
		}
	}

	debounce(func, wait, immediate) {
		let timeout;
		return function () {
			let context = this, args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

}



// WEBPACK FOOTER //
// ./components/product-offering/product-offering.component.ts